export default __webpack_public_path__ + "static/media/overcast.7c78809e.png";